import { createContext, ReactNode } from "react";

export interface FeatureFlags {
  CORE_PRODUCTS: boolean;
  // Adicione outras feature flags aqui conforme necessário
}

export interface IFeatureFlagsContext {
  flags: FeatureFlags;
}

const defaultFlags: FeatureFlags = {
  CORE_PRODUCTS: false, // Desabilitado por padrão
};

export const FeatureFlagsContext = createContext<IFeatureFlagsContext>({
  flags: defaultFlags,
});

interface FeatureFlagsProviderProps {
  children: ReactNode;
  flags?: Partial<FeatureFlags>;
}

const FeatureFlagsProvider = ({
  children,
  flags: customFlags,
}: FeatureFlagsProviderProps) => {
  const flags: FeatureFlags = {
    ...defaultFlags,
    ...customFlags,
  };

  return (
    <FeatureFlagsContext.Provider value={{ flags }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export default FeatureFlagsProvider;
